// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oX8R","field":"styles_field__2TL3P","fieldCol":"styles_fieldCol__17XM4","diffCol":"styles_diffCol__3sq36","diff":"styles_diff__3DnyL"};